import React, { Component, ComponentType } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { WithTranslation, withTranslation } from 'react-i18next';
import { connect, ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { RootState } from '../../store';
import { IEciImplantDetailsContainerStateProps, IEciImplantDetailsContainerDispatchProps } from '../../interfaces/props/IEciImplantDetailsProps';
import * as eciImplantDetailsStore from '../../store/modules/eciImplantDetails.store';
import './eciImplantDetails.container.scss';

import { Validator } from '../../common/model/enumerations/validator.model';
import ValidationError from '../../components/validationError/validationError';
import TextBox from '../../components/filters/textBox';
import { FormValidator, FormEventArgs } from '@syncfusion/ej2-react-inputs';
import { IErrors } from '../../common/model/errors.model';
import { isIResponseError, getData, IResponseData, IFile } from '../../common/model/responseError.model';
import * as formValidatorUtils from '../../utils/formValidator.utils';
import { eciImplantsService } from '../../services';
import { notifyWarningWithOptions, notifyErrorWithOptions, notifyInfoWithOptions } from '../../utils/toast.utils';
import { isNullOrWhitespace } from '../../utils/string.utils';
import { AxiosResponse } from 'axios';
import { DropDownListComponent, ChangeEventArgs, MultiSelectComponent, FieldSettingsModel, FilteringEventArgs } from '@syncfusion/ej2-react-dropdowns';
import { Query } from '@syncfusion/ej2-data';

type EciImplantContainerPropsType = PropsFromRedux & RouteComponentProps & WithTranslation;

class EciImplantDetailsContainer extends Component<EciImplantContainerPropsType> {
  public seasonAppFormDropDownListComponent: DropDownListComponent = null;

  public seasonEciForecastDropDownListComponent: DropDownListComponent = null;
  public seasonEciForecastFields: FieldSettingsModel = { text: 'Code', value: 'Code' };
  public seasonEciForecastOptions: { [key: string]: any }[] = [
    { Code: "SS25" }, { Code: "AW25" }, { Code: "SS26" }, { Code: "AW26" },
    { Code: "SS27" }, { Code: "AW27" }, { Code: "SS28" }, { Code: "AW28" },
    { Code: "SS29" }, { Code: "AW29" }, { Code: "SS30" }, { Code: "AW30" }
  ];

  public officeEciForecastMultiSelectComponent: MultiSelectComponent = null;
  public officeEciForecastFields: FieldSettingsModel = { text: 'Code', value: 'Code' };
  public officeEciForecastOptions: { [key: string]: any }[] = [
    { Code: "DAC" }, { Code: "DEL" }, { Code: "HCM" }, { Code: "HKG" }, { Code: "IST" },
    { Code: "KHI" }, { Code: "LIM" }, { Code: "LIS" }, { Code: "LSB" }, { Code: "MAD" },
    { Code: "NYC" }, { Code: "SHG" }, { Code: "SOF" }, { Code: "TAN" }, { Code: "TNG" },
  ];

  public selectedOffices: string[] = [this.officeEciForecastOptions[0].Code];

  public actionEciForecastMultiSelectComponent: MultiSelectComponent = null;
  public actionEciForecastFields: FieldSettingsModel = { text: 'Text', value: 'Value' };
  public actionEciForecastOptions: { [key: string]: any }[] = [
    { Value: "<Sin cambios>", Text: "Sin cambios/No Changes" },
    { Value: "Nuevo", Text: "Nuevo/New" },
    { Value: "Modificado", Text: "Modificado/Modified" }
  ];

  public selectedActions: string[] = this.actionEciForecastOptions.map((item) => { return item.Value; });

  public filesToUpload: HTMLInputElement = null;
  public files: FileList;

  private readonly DOWNLOAD_FILLED_ECI_APPFORM_FORM_ID = 'downloadFilledEciAppFormForm';
  private readonly UPLOAD_FILLED_ECI_APPFORM_FORM_ID = 'uploadFilledEciAppFormForm';
  private readonly DOWNLOAD_ECI_FORECAST_FORM_ID = 'downloadEciForecast';
  private formValidatorEciForecast: FormValidator = null;
  private formValidator: FormValidator = null;
  private isValidatingAll = false;
  private auxErrors: IErrors = {};

  public constructor(props: EciImplantContainerPropsType) {
    super(props);
  }

  public componentDidMount() {
    this.changeSeason(this.seasonEciForecastOptions[0].Code);
  }

  public onSelectionNumberChange(selectionNumber: string): void {
    const { setSelectionNumber } = this.props;

    if (setSelectionNumber) {
      setSelectionNumber(selectionNumber);
    }
  }

  private changeSeason(season: string) {
    const { setSeason } = this.props;

    if (setSeason) {
      setSeason(season);
    }
  }

  public onSeasonChange(e: ChangeEventArgs) {
    const season = e.value as string;
    this.changeSeason(season);
  }

  public onSupplierCodeChange(supplierCode: string): void {
    const { setSupplierCode } = this.props;

    if (setSupplierCode) {
      setSupplierCode(supplierCode);
    }
  }

  public onReferenceChange(reference: string): void {
    const { setReference } = this.props;

    if (setReference) {
      setReference(reference);
    }
  }

  public onStyleChange(style: string): void {
    const { setStyle } = this.props;

    if (setStyle) {
      setStyle(style);
    }
  }

  public closeEciForecast(): void {
    this.formValidatorEciForecast = null;
  }

  public close(): void {
    this.formValidator = null;
  }

  private validateForm(): boolean {
    const { setErrors } = this.props;
    if (!this.formValidator) {
      return true;
    }

    this.isValidatingAll = true;
    const isFormValid = this.formValidator.validate();
    this.isValidatingAll = false;

    if (!isFormValid) {
      setErrors(this.auxErrors);
      this.auxErrors = {};
    } else {
      setErrors({});
    }

    return isFormValid;
  }

  private validateEciForecastForm(): boolean {
    const { setErrors } = this.props;
    if (!this.formValidator) {
      return true;
    }

    this.isValidatingAll = true;
    const isFormValid = this.formValidatorEciForecast.validate();
    this.isValidatingAll = false;

    if (!isFormValid) {
      setErrors(this.auxErrors);
      this.auxErrors = {};
    } else {
      setErrors({});
    }

    return isFormValid;
  }

  public async downloadEciForecastForm(): Promise<void> {
    const { setErrors, setSpinnerDownloadEciForecast } = this.props;

    try {
      if (!this.validateEciForecastForm()) {
        return;
      }

      const season = this.seasonEciForecastDropDownListComponent.value as string;
      this.selectedOffices = this.officeEciForecastMultiSelectComponent.value as string[];
      this.selectedActions = this.actionEciForecastMultiSelectComponent.value as string[];

      setSpinnerDownloadEciForecast(true);

      await eciImplantsService.downloadEciForecastFile(season, this.selectedOffices, this.selectedActions);
      this.closeEciForecast();
    } catch (ex) {
      let errors: IErrors = {};
      let response: AxiosResponse = null;
      if (isIResponseError(ex)) {
        errors = ex.errors;
        response = ex.bodyResponse
      } else {
        errors = ex as IErrors;
      }

      if (errors.EciSeason || errors.Office) {
        setErrors(errors);
        return;
      }

      if (response) {
        getData(response).then((data: IResponseData) => {
          let message = data !== undefined && data != null
            ? data.error !== undefined && data.error != null
              ? data.error.message !== undefined && data.error.message != null && data.error.message.trim() != ''
                ? data.error.message
                : data.error.messageException
              : ''
            : 'The response does not have a defined message';

          if (isNullOrWhitespace(message) && data.errors !== undefined && data.errors != null) {
            const errorsArray = Array.isArray(data.errors) ? data.errors : Object.values(data.errors);
            message = errorsArray.map((error: any) => {
              if (typeof error === 'string') {
                return error;
              } else if (error.message) {
                return error.message;
              } else {
                return JSON.stringify(error);
              }
            }).join(';');
          }

          const file = this.GetBlobFile(data.file);

          if (file != null) {
            const url = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = data.file.fileName;
            link.click();
            window.URL.revokeObjectURL(url);

            notifyWarningWithOptions(message.replace(/<[^>]*>?/gm, ''), { autoClose: false });
          } else {
            notifyErrorWithOptions(message.replace(/<[^>]*>?/gm, ''), { autoClose: false });
          }
        });
      }
    } finally {
      setSpinnerDownloadEciForecast(false);
    }
  }

  public async downloadFilledEciAppForm(): Promise<void> {
    const { setErrors, setSpinnerDownloadFilledEciAppForm } = this.props;

    try {
      if (!this.validateForm()) {
        return;
      }

      const { selectionNumber, season, supplierCode, reference, style } = this.props;

      setSpinnerDownloadFilledEciAppForm(true);

      await eciImplantsService.downloadFile(season, selectionNumber, supplierCode, reference, style);
      this.close();
    } catch (ex) {
      let errors: IErrors = {};
      let response: AxiosResponse = null;
      if (isIResponseError(ex)) {
        errors = ex.errors;
        response = ex.bodyResponse
      } else {
        errors = ex as IErrors;
      }

      if (errors.SelectionNumber || errors.Season) {
        setErrors(errors);
        return;
      }

      if (response) {
        getData(response).then((data: IResponseData) => {
          let message = data !== undefined && data != null
            ? data.error !== undefined && data.error != null
              ? data.error.message !== undefined && data.error.message != null && data.error.message.trim() != ''
                ? data.error.message
                : data.error.messageException
              : ''
            : 'The response does not have a defined message';

          if (isNullOrWhitespace(message) && data.errors !== undefined && data.errors != null) {
            const errorsArray = Array.isArray(data.errors) ? data.errors : Object.values(data.errors);
            message = errorsArray.map((error: any) => {
              if (typeof error === 'string') {
                return error;
              } else if (error.message) {
                return error.message;
              } else {
                return JSON.stringify(error);
              }
            }).join(';');
          }

          const file = this.GetBlobFile(data.file);

          if (file != null) {
            const url = window.URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = url;
            link.download = data.file.fileName;
            link.click();
            window.URL.revokeObjectURL(url);

            notifyWarningWithOptions(message.replace(/<[^>]*>?/gm, ''), { autoClose: false });
          } else {
            notifyErrorWithOptions(message.replace(/<[^>]*>?/gm, ''), { autoClose: false });
          }
        });
      }
    } finally {
      setSpinnerDownloadFilledEciAppForm(false);
    }
  }

  private GetBlobFile(file: IFile): Blob {
    if (file !== undefined && file != null && file.stream !== undefined && file.stream != null) {
      // Convertir el archivo base64 a un Blob
      const byteCharacters = atob(file.stream);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: file.mimeType });

      return blob;
    }

    return null;
  }

  public onFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const maxFilesCount = 5;
    const files = event.target.files;
    const { i18n } = this.props

    if (files && files.length > maxFilesCount) {
      notifyErrorWithOptions(i18n.t('eciImplant.uploadMaxFilesCount').replace('{0}', maxFilesCount.toString()).replace('{1}', files.length.toString()), { autoClose: false });
      event.target.value = '';
    } else {
      this.files = files;
    }
  };

  public async uploadFilledEciAppForm(e: React.FormEvent<HTMLFormElement>): Promise<void> {
    e.preventDefault();

    const { i18n, setSpinnerUploadFilledEciAppForm, user } = this.props

    setSpinnerUploadFilledEciAppForm(true);

    try {
      await eciImplantsService.uploadFilesToQueue(this.files, null, user.email);
      notifyInfoWithOptions(i18n.t('eciImplant.uploadFilledAppFormToQueueSuccess'), { autoClose: false });

      this.files = null;
      this.filesToUpload.value = '';
    } catch (ex) {
      let errors: IErrors = {};
      let response: AxiosResponse = null;
      if (isIResponseError(ex)) {
        errors = ex.errors;
        response = ex.bodyResponse
      } else {
        errors = ex as IErrors;
      }

      if (response) {
        getData(response).then((data: IResponseData) => {
          let message = data !== undefined && data != null
            ? data.error !== undefined && data.error != null
              ? data.error.message !== undefined && data.error.message != null && data.error.message.trim() != ''
                ? data.error.message
                : data.error.messageException
              : ''
            : 'The response does not have a defined message';

          if (isNullOrWhitespace(message) && data.errors !== undefined && data.errors != null) {
            const errorsArray = Array.isArray(data.errors) ? data.errors : Object.values(data.errors);
            message = errorsArray.map((error: any) => {
              if (typeof error === 'string') {
                return error;
              } else if (error.message) {
                return error.message;
              } else {
                return JSON.stringify(error);
              }
            }).join(';');
          }

          if (!isNullOrWhitespace(message)) {
            notifyErrorWithOptions(`${i18n.t('eciImplant.uploadFilledAppFormError')}. ERROR: ${message}`, { autoClose: false });
          } else {
            notifyErrorWithOptions(`${i18n.t('eciImplant.uploadFilledAppFormError')}.`, { autoClose: false });
          }
        });
      } else {
        notifyErrorWithOptions(`${i18n.t('eciImplant.uploadFilledAppFormError')}. ERROR: ${errors}`, { autoClose: false });
      }
    } finally {
      setSpinnerUploadFilledEciAppForm(false);
    }
  }

  public configureEciForecastFormValidator(): void {
    if (!this.formValidatorEciForecast) {
      this.formValidatorEciForecast = formValidatorUtils.configureFormValidator(this.DOWNLOAD_ECI_FORECAST_FORM_ID, {
        EciSeason: {
          required: [true, Validator.NOT_EMPTY]
        },
        Office: {
          required: [true, Validator.NOT_EMPTY]
        },
        Action: {
          required: [true, Validator.NOT_EMPTY]
        }
      });
      this.formValidatorEciForecast.validationComplete = (args) => {
        formValidatorUtils.validationComplete(args as FormEventArgs, this.isValidatingAll, this.props.errors, this.auxErrors, (errors): void => this.setState({ errors }));
      };
    }
  }

  public validateOtherFields(args: any): boolean {
    const selectionNumber = args.element.form[1].value;
    const supplierCode = args.element.form[4].value;
    const reference = args.element.form[6].value;
    const style = args.element.form[7].value;

    const result = !isNullOrWhitespace(selectionNumber)
      || !isNullOrWhitespace(supplierCode)
      || !isNullOrWhitespace(reference)
      || !isNullOrWhitespace(style);

    return result;
  }

  public configureFormValidator(): void {
    if (!this.formValidator) {
      this.formValidator = formValidatorUtils.configureFormValidator(this.DOWNLOAD_FILLED_ECI_APPFORM_FORM_ID, {
        Season: {
          required: [true, Validator.NOT_EMPTY]
        }
      });

      this.formValidator.addRules('SelectionNumber', { required: [this.validateOtherFields, 'NotEmptyAppFormFieldsValidator'] });

      this.formValidator.validationComplete = (args) => {
        formValidatorUtils.validationComplete(args as FormEventArgs, this.isValidatingAll, this.props.errors, this.auxErrors, (errors): void => this.setState({ errors }));
      };
    }
  }

  public render() {
    const {
      selectionNumber,
      season,
      supplierCode,
      reference,
      style,
      errors,
      i18n,
      showSpinnerDownloadEciForecastFile,
      showSpinnerDownloadFile,
      showSpinnerUploadFile
    } = this.props;

    return (
      <div>
        <div>
          <form id={this.DOWNLOAD_ECI_FORECAST_FORM_ID} ref={(): void => this.configureEciForecastFormValidator()} onSubmit={(e: React.FormEvent) => { e.preventDefault(); this.downloadEciForecastForm() }}>
            <fieldset id='m'>
              <legend>{i18n.t('eciImplant.downloadEciForecast')}</legend>
              <div className='row'>
                <div className='col'>
                  <div className='form-group'>
                    <div className='autocomplete-input'>
                      <div className='autocomplete-label'>{i18n.t('eciImplant.season')}</div>
                      <DropDownListComponent
                        ref={(dropDownListComponent) => {
                          this.seasonEciForecastDropDownListComponent = dropDownListComponent;
                        }}
                        name="EciSeason"
                        dataSource={this.seasonEciForecastOptions}
                        fields={this.seasonEciForecastFields}
                        value={season !== undefined && season != null && season.trim() !== '' ? season : this.seasonEciForecastOptions[0].Code}
                        allowFiltering={true}
                        filtering={(e: FilteringEventArgs) => {
                          let query = new Query();
                          query = (e.text != "") ? query.where("Code", "contains", e.text, true) : query;
                          e.updateData(this.seasonEciForecastOptions, query);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className='col'>
                  <div className='form-group'>
                    <div className='autocomplete-input'>
                      <div className='autocomplete-label'>{i18n.t('eciImplant.office')}</div>
                      <MultiSelectComponent
                        ref={(multiSelectComponent) => {
                          this.officeEciForecastMultiSelectComponent = multiSelectComponent;
                        }}
                        name="Office"
                        fields={this.officeEciForecastFields}
                        dataSource={this.officeEciForecastOptions}
                        mode='CheckBox'
                        showSelectAll={true}
                        selectAllText={i18n.t('actions.selectAll')}
                        unSelectAllText={i18n.t('actions.unselectAll')}
                        value={this.selectedOffices}
                        allowFiltering={true}
                        filtering={(e: FilteringEventArgs) => {
                          let query = new Query();
                          query = (e.text != "") ? query.where("Code", "contains", e.text, true) : query;
                          e.updateData(this.officeEciForecastOptions, query);
                        }}
                      />
                    </div>
                    <ValidationError errors={errors} errorKey={'Office'} />
                  </div>
                </div>
                <div className='col'>
                  <div className='form-group'>
                    <div className='autocomplete-input'>
                      <div className='autocomplete-label'>{i18n.t('eciImplant.action')}</div>
                      <MultiSelectComponent
                        ref={(multiSelectComponent) => {
                          this.actionEciForecastMultiSelectComponent = multiSelectComponent;
                        }}
                        name="Action"
                        fields={this.actionEciForecastFields}
                        dataSource={this.actionEciForecastOptions}
                        mode='CheckBox'
                        showSelectAll={true}
                        selectAllText={i18n.t('actions.selectAll')}
                        unSelectAllText={i18n.t('actions.unselectAll')}
                        value={this.selectedActions}
                        allowFiltering={true}
                        filtering={(e: FilteringEventArgs) => {
                          let query = new Query();
                          query = (e.text != "") ? query.where("Text", "contains", e.text, true) : query;
                          e.updateData(this.actionEciForecastOptions, query);
                        }}
                      />
                    </div>
                    <ValidationError errors={errors} errorKey={'Action'} />
                  </div>
                </div>
                <div className='col'>
                  <button
                    role='submit'
                    className='btn btn-sm btn-light'
                    title={i18n.t('eciImplant.downloadEciForecast')}
                    disabled={showSpinnerDownloadEciForecastFile}
                  >
                    <span className={(showSpinnerDownloadEciForecastFile ? 'spinner-border spinner-border-sm' : 'icon icon-app-file-download')}></span>
                  </button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
        <hr />
        <div>
          <form id={this.DOWNLOAD_FILLED_ECI_APPFORM_FORM_ID} ref={(): void => this.configureFormValidator()} onSubmit={(e: React.FormEvent) => { e.preventDefault(); this.downloadFilledEciAppForm() }}>
            <fieldset id='m'>
              <legend>{i18n.t('eciImplant.downloadFilledAppForm')}</legend>
              <div className='row'>
                <div className='col'>
                  <div className='form-group'>
                    <div className='autocomplete-input'>
                      <div className='autocomplete-label'>{i18n.t('eciImplant.selectionNumber')}</div>
                      <TextBox
                        name='SelectionNumber'
                        value={selectionNumber}
                        onChange={(value): void => this.onSelectionNumberChange(value)}
                      />
                    </div>
                    <ValidationError errors={errors} errorKey={'SelectionNumber'} />
                  </div>
                </div>
                <div className='col'>
                  <div className='form-group'>
                    <div className='autocomplete-input'>
                      <div className='autocomplete-label'>{i18n.t('eciImplant.season')}</div>
                      <DropDownListComponent
                        ref={(dropDownListComponent) => {
                          this.seasonAppFormDropDownListComponent = dropDownListComponent;
                        }}
                        name="Season"
                        dataSource={this.seasonEciForecastOptions}
                        fields={this.seasonEciForecastFields}
                        value={this.seasonEciForecastOptions[0].Code}
                        allowFiltering={true}
                        filtering={(e: FilteringEventArgs) => {
                          let query = new Query();
                          query = (e.text != "") ? query.where("Code", "contains", e.text, true) : query;
                          e.updateData(this.seasonEciForecastOptions, query);
                        }}
                        change={(e) => this.onSeasonChange(e)}
                      />
                      </div>
                      <ValidationError errors={errors} errorKey={'Season'} />
                    </div>
                  </div>
                  <div className='col'>
                    <div className='form-group'>
                      <div className='autocomplete-input'>
                        <div className='autocomplete-label'>{i18n.t('eciImplant.supplierCode')}</div>
                        <TextBox
                          name='SupplierCode'
                          value={supplierCode}
                          onChange={(value): void => this.onSupplierCodeChange(value)}
                        />
                      </div>
                      <ValidationError errors={errors} errorKey={'SupplierCode'} />
                    </div>
                  </div>
                  <div className='col'>
                  <button
                    role='submit'
                    className='btn btn-sm btn-light'
                    title={i18n.t('eciImplant.downloadFilledAppForm')}
                    disabled={showSpinnerDownloadFile}
                  >
                    <span className={(showSpinnerDownloadFile ? 'spinner-border spinner-border-sm' : 'icon icon-app-file-download')}></span>
                    </button>
                  </div>
              </div>
              <div className='row'>
                <div className='col'>
                  <div className='form-group'>
                    <div className='autocomplete-input'>
                      <div className='autocomplete-label'>{i18n.t('eciImplant.reference')}</div>
                      <TextBox
                        name='Reference'
                        value={reference}
                        onChange={(value): void => this.onReferenceChange(value)}
                      />
                    </div>
                    <ValidationError errors={errors} errorKey={'Reference'} />
                  </div>
                </div>
                <div className='col'>
                  <div className='form-group'>
                    <div className='autocomplete-input'>
                      <div className='autocomplete-label'>{i18n.t('eciImplant.style')}</div>
                      <TextBox
                        name='Style'
                        value={style}
                        onChange={(value): void => this.onStyleChange(value)}
                      />
                    </div>
                    <ValidationError errors={errors} errorKey={'Style'} />
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
        <hr />
        <div>
          <div dangerouslySetInnerHTML={{ __html: i18n.t('eciImplant.infoUploadAppForm') }}></div>
          <form id={this.UPLOAD_FILLED_ECI_APPFORM_FORM_ID} encType="multipart/form-data" onSubmit={(e: React.FormEvent<HTMLFormElement>) => { e.preventDefault(); this.uploadFilledEciAppForm(e); }}>
            <fieldset id='m2'>
              <legend>{i18n.t('eciImplant.uploadFilledAppForm')}</legend>
              <div className='row'>
                <div className='col'>
                  <div className='form-group'>
                    <div className='autocomplete-input'>
                      <div className='autocomplete-label'>{i18n.t('eciImplant.filledAppForm')}</div>
                      <input type='file'
                        ref={(element: HTMLInputElement): HTMLInputElement => this.filesToUpload = element}
                        onChange={this.onFileChange}
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        multiple
                      >
                      </input>
                    </div>
                  </div>
                </div>
                <div className='col'>
                  <button role='submit'
                    className='btn btn-sm btn-light'
                    title={i18n.t('eciImplant.uploadFilledAppForm')}
                    disabled={showSpinnerUploadFile}
                  >
                    <span className={(showSpinnerUploadFile ? 'spinner-border spinner-border-sm' : 'icon icon-app-action-send-email')}></span>
                  </button>
                </div>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState): IEciImplantDetailsContainerStateProps => ({
  selectionNumber: state.eciImplantDetailsStore.selectionNumber,
  season: state.eciImplantDetailsStore.season,
  supplierCode: state.eciImplantDetailsStore.supplierCode,
  reference: state.eciImplantDetailsStore.reference,
  style: state.eciImplantDetailsStore.style,
  errors: state.eciImplantDetailsStore.errors,
  user: state.currentUserStore.user,
  showSpinnerDownloadEciForecastFile: state.eciImplantDetailsStore.downloadEciForecastFileSpinner,
  showSpinnerUploadFile: state.eciImplantDetailsStore.uploadFileSpinner,
  showSpinnerDownloadFile: state.eciImplantDetailsStore.downloadFileSpinner
});

const mapDispatchToProps: IEciImplantDetailsContainerDispatchProps = {
  setSelectionNumber: eciImplantDetailsStore.setSelectionNumberInState,
  setSeason: eciImplantDetailsStore.setSeasonInState,
  setSupplierCode: eciImplantDetailsStore.setSupplierCodeInState,
  setReference: eciImplantDetailsStore.setReferenceInState,
  setStyle: eciImplantDetailsStore.setStyleInState,
  setSpinnerDownloadEciForecast: eciImplantDetailsStore.spinnerDownloadEciForecast,
  setSpinnerDownloadFilledEciAppForm: eciImplantDetailsStore.spinnerDownloadFilledEciAppForm,
  setSpinnerUploadFilledEciAppForm: eciImplantDetailsStore.spinnerUploadFilledEciAppForm,
  setErrors: eciImplantDetailsStore.setErrorsInState
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default compose(
  withRouter,
  withTranslation(),
  connector
)(EciImplantDetailsContainer) as ComponentType;
